import { fromZonedTime } from "date-fns-tz";
import { APP_CONFIG } from "../../../constants/constants";
import {
  formattedDateTimeBasedOnTimezone,
  getStartEndOfDayInUTC,
  jsTimeToDBTime,
} from "../../../utils/dateTime";
import { convertToTZForDateFnsNoHook } from "../../../hooks/timezone";

export const calculatedTimeFilters = (
  selected_date: string,
  timezone: string
) => {
  if (APP_CONFIG.DEBUG.ALL)
    console.log(
      "ASSETFILT ====================== selected_date",
      selected_date
    );

  const { startOfDayInUTC, endOfDayInUTC } = getStartEndOfDayInUTC(
    selected_date,
    timezone
  );

  const preparedFilterData = {
    selected_date,
    date_from: selected_date, // !!date_from ? date_from.toISOString().split('T')[0] : "",
    time_from: formattedDateTimeBasedOnTimezone(
      startOfDayInUTC,
      timezone || APP_CONFIG.DEFAULT_TIMEZONE,
      "HH:mm:ss"
    ), // !!date_from ? date_from.toISOString().split('T')[1].split('.')[0] : "",
    date_to: selected_date, // !!date_from ? date_to.toISOString().split('T')[0] : "",
    time_to: formattedDateTimeBasedOnTimezone(
      endOfDayInUTC,
      timezone || APP_CONFIG.DEFAULT_TIMEZONE,
      "HH:mm:ss"
    ), // !!date_from ? date_to.toISOString().split('T')[1].split('.')[0] : "",
    timezone,
    calculatedUnixTimestampFrom: jsTimeToDBTime(startOfDayInUTC.getTime()),
    calculatedUnixTimestampTo: jsTimeToDBTime(endOfDayInUTC.getTime()),
  };
  if (APP_CONFIG.DEBUG.ALL)
    console.log("ASSETFILT preparedFilterData", preparedFilterData);
  return preparedFilterData;
  const { calculatedUnixTimestampFrom, calculatedUnixTimestampTo } =
    computedUnixTimestamps(
      preparedFilterData.date_from,
      preparedFilterData.time_from,
      preparedFilterData.date_to,
      preparedFilterData.time_to,
      preparedFilterData.timezone
    );
  const newFilterData = {
    ...preparedFilterData,
    calculatedUnixTimestampFrom,
    calculatedUnixTimestampTo,
  };
  if (APP_CONFIG.DEBUG.ALL)
    console.log("ASSETFILT newFilterData", newFilterData);
  return newFilterData;
};

export const computedUnixTimestamps = (
  date_from: string,
  time_from: string,
  date_to: string,
  time_to: string,
  timezone: string
) => {
  let calculatedUnixTimestampFrom = null;
  let calculatedUnixTimestampTo = null;
  if (!!date_from && !!time_from && !!timezone) {
    const selectedDate = `${date_from} ${time_from}`; // :00
    const utcDate = fromZonedTime(
      selectedDate,
      convertToTZForDateFnsNoHook(timezone)
    );
    const jsTime = new Date(utcDate).getTime();
    if (!!jsTime && !isNaN(jsTime)) {
      calculatedUnixTimestampFrom = jsTime / 1000;
      if (APP_CONFIG.DEBUG.ALL)
        console.log("unixTimestampFrom", calculatedUnixTimestampFrom);
    } else {
      if (APP_CONFIG.DEBUG.ALL)
        console.error("Invalid datetime (from)", jsTime);
    }
  }
  if (!!date_to && !!time_to && !!timezone) {
    const selectedDate = `${date_to} ${time_to}`; // :00
    const utcDate = fromZonedTime(
      selectedDate,
      convertToTZForDateFnsNoHook(timezone)
    );
    const jsTime = new Date(utcDate).getTime();
    if (!!jsTime && !isNaN(jsTime)) {
      calculatedUnixTimestampTo = jsTime / 1000;
      if (APP_CONFIG.DEBUG.ALL)
        console.log("unixTimestampTo", calculatedUnixTimestampTo);
    } else {
      if (APP_CONFIG.DEBUG.ALL) console.error("Invalid datetime (to)", jsTime);
    }
  }
  return { calculatedUnixTimestampFrom, calculatedUnixTimestampTo };
};
